jQuery(function ($) {
  var swiper;
  $.Swiper = function () {
  };

  $.Swiper.prototype = {
    swiper: $('.swiper-carousel-simple'),
    swiper_items_per_page_xs: 1,
    swiper_items_per_page_sm: 2,
    swiper_items_per_page_md: 3,
    swiper_items_per_page_lg: 4,
    swiper_one_side_padding: false,
    slideClass: 'swiper-slide',

    init: function () {
      var parent = this;

      /**
       * Sets css classes to define how much slides should show in current viewport width.
       * Don't use swiper breakpoint instead (onesidePadding calc would fail)
       */
      var setSizes = function (instance) {
        var $swiperItemsPerPageXs = parent.swiper_items_per_page_xs;
        var $swiperItemsPerPageSm = parent.swiper_items_per_page_sm;
        var $swiperItemsPerPageMd = parent.swiper_items_per_page_md;
        var $swiperItemsPerPageLg = parent.swiper_items_per_page_lg;

        // Check Default
        if (instance.attr('data-items-per-page-default') !== ''
          && typeof instance.attr('data-items-per-page-default') !== 'undefined') {
          $swiperItemsPerPageXs = 1;

          $swiperItemsPerPageSm = parseInt(instance.attr('data-items-per-page-default'), 10);
          if ($swiperItemsPerPageSm > parent.swiper_items_per_page_sm) {
            $swiperItemsPerPageSm = parent.swiper_items_per_page_sm;
          }

          $swiperItemsPerPageMd = parseInt(instance.attr('data-items-per-page-default'), 10);
          if ($swiperItemsPerPageMd > parent.swiper_items_per_page_md) {
            $swiperItemsPerPageMd = parent.swiper_items_per_page_md;
          }

          $swiperItemsPerPageLg = parseInt(instance.attr('data-items-per-page-default'), 10);
        }

        // Check XS
        if (instance.attr('data-swiper-items-per-page-xs') !== ''
          && typeof instance.attr('data-swiper-items-per-page-xs') !== 'undefined') {
          $swiperItemsPerPageXs = parseInt(instance.attr('data-swiper-items-per-page-xs'), 10);
        }

        // Check SM
        if (instance.attr('data-swiper-items-per-page-sm') !== ''
          && typeof instance.attr('data-swiper-items-per-page-sm') !== 'undefined') {
          $swiperItemsPerPageSm = parseInt(instance.attr('data-swiper-items-per-page-sm'), 10);
        }

        // Check MD
        if (instance.attr('data-swiper-items-per-page-md') !== ''
          && typeof instance.attr('data-swiper-items-per-page-md') !== 'undefined') {
          $swiperItemsPerPageMd = parseInt(instance.attr('data-swiper-items-per-page-md'), 10);
        }

        // Check LG
        if (instance.attr('data-swiper-items-per-page-lg') !== ''
          && typeof instance.attr('data-swiper-items-per-page-lg') !== 'undefined') {
          $swiperItemsPerPageLg = parseInt(instance.attr('data-swiper-items-per-page-lg'), 10);
        }

        instance.find('.' + parent.slideClass).addClass(
          'swiper-col-xs-' + $swiperItemsPerPageXs + ' swiper-col-sm-' + $swiperItemsPerPageSm
          + ' swiper-col-md-' + $swiperItemsPerPageMd + ' swiper-col-lg-' + $swiperItemsPerPageLg
        );
      };

      $.fn.isInViewport = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
      };

      parent.swiper.each(function () {
        var $this = $(this);
        var that = this;
        var swiperOptions;
        var lazyloaded;
        var swiperInstance;

        var $swiperOneSidePadding = parent.swiper_one_side_padding;

        // Check OneSidePadding
        if ($this.attr('data-one-side-padding') !== ''
          && typeof $this.attr('data-one-side-padding') !== 'undefined') {
          if ($this.attr('data-one-side-padding') === 'false') {
            $swiperOneSidePadding = 0;
          } else {
            $swiperOneSidePadding = parseInt($this.attr('data-one-side-padding'), 10);
          }
        }

        setSizes($this);

        swiperOptions = {
          init: false,
          preloadImages: false,
          lazy: {
            loadPrevNext: true
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          slidesPerView: 'auto',
          watchSlidesVisibility: true,
          slideClass: parent.slideClass
        };

        if ($this.find('.swiper-navigation-container').length > 0) {
          swiperOptions.navigation = {
            nextEl: '.button-next',
            prevEl: '.button-prev'
          };
        }

        $this.swiperCarouselRetina({
          beforeInit: true
        });
        $this.swiperCarouseloneSidePadding({
          oneSidePadding: $swiperOneSidePadding,
          slideClass: parent.slideClass
        });

        swiperInstance = new Swiper(that, swiperOptions);

        swiperInstance.on('resize', function () {
          $this.swiperCarouseloneSidePadding({
            oneSidePadding: $swiperOneSidePadding,
            slideClass: parent.slideClass
          });
        });

        lazyloaded = false;

        $(window).on('DOMContentLoaded load resize scroll', function () {
          var inViewport = $this.isInViewport();

          if (!lazyloaded && inViewport !== lazyloaded) {
            lazyloaded = true;
            swiperInstance.lazy.load();
          }
        });

        swiperInstance.init();
      });
    }
  };

  swiper = new $.Swiper();

  swiper.init();
});
